import headMenu from '@/utils';
export default defineNuxtPlugin(() => {
  return {
    provide: {
        headMenu: () => headMenu
    }
  }
})